/* eslint-disable-next-line */
import { getData, postData, delData, putData } from './axios.js'
import { getAxiosUrl, proName } from '@/js/public'
const version = `api/${proName}`
const SUPER_IDEN = 'super'
const AUTH_IDEN = 'auth'
export const api = {
  uploadPdf: (orgCode) => `${getAxiosUrl('admin')}/${version}/${SUPER_IDEN}/upload`
}
// 获取案例列表
export const getCaseList = (orgID, data, isLoading, callback) => getData(`${version}/${SUPER_IDEN}/case/${orgID}/org_case`, data, 'admin', isLoading, callback)
// 添加案例
export const addCase = (orgID, data, isLoading, callback) => postData(`${version}/${SUPER_IDEN}/case/${orgID}/org_case`, data, 'admin', isLoading, callback)
export const editCase = (orgID, caseID, data, isLoading, callback) => putData(`${version}/${SUPER_IDEN}/case/${orgID}/org_case/${caseID}`, data, 'admin', isLoading, callback)
export const removeCase = (orgID, caseID, data, isLoading, callback) => delData(`${version}/${SUPER_IDEN}/case/${orgID}/org_case/${caseID}`, data, 'admin', isLoading, callback)
export const uploadFile = (data, isLoading, callback) => postData(`${version}/${SUPER_IDEN}/upload`, data, 'admin', isLoading, callback)

// 公共查询
export const orgRegSearch = (data, isLoading, callback) => getData(`${version}/reg_search`, data, 'admin', isLoading, callback)
export const orgExport = (isLoading, callback) => getData(`${version}/export`, '', 'admin', isLoading, callback)
// 获取学校列表
export const getSchoolListFromType = (data, isLoading, callback) => getData(`${version}/lib_search`, data, 'admin', isLoading, callback)
export const schoolOrgAdd = (data, isLoading, callback) => postData(`${version}/register`, data, 'admin', isLoading, callback)
export const sendSms = (data, isLoading, callback) => postData(`${version}/send_sms`, data, 'admin', isLoading, callback)
// 获取后台左侧菜单栏
export const supGetMuneInfo = (data, isLoading, callback) => getData(`${version}/menu`, data, 'admin', isLoading, callback)
// 左侧菜单栏
export const orgGetMuneInfo = (orgID, data, isLoading, callback) => getData(`${version}/${orgID}/menu`, data, 'admin', isLoading, callback)
// 获取机构信息
export const getOrgInfo = (orgID, isLoading, callback) => getData(`${version}/${orgID}/lib_detail`, '', 'admin', isLoading, callback)
// 获取机构下的作品列表
export const orgGetWorkList = (orgID, data, isLoading, callback) => getData(`${version}/${orgID}/creation_list`, data, 'admin', isLoading, callback)
export const workCancelRec = (orgID, workID, isLoading, callback) => putData(`${version}/${orgID}/cancel_rec/${workID}`, '', 'admin', isLoading, callback)
export const workRec = (orgID, workID, isLoading, callback) => putData(`${version}/${orgID}/creation_rec/${workID}`, '', 'admin', isLoading, callback)
// 机构列表
export const orgList = (data, isLoading, callback) => getData(`${version}/${SUPER_IDEN}/lib_list`, data, 'admin', isLoading, callback)
// 学校列表
export const schoolList = (isLoading, callback) => getData(`${version}/${SUPER_IDEN}/lib_search`, '', 'admin', isLoading, callback)
export const orgCodeList = (isLoading, callback) => getData(`${version}/${SUPER_IDEN}/reader_org`, '', 'admin', isLoading, callback)
export const actIDList = (data, isLoading, callback) => getData(`${version}/${SUPER_IDEN}/reader_act`, data, 'admin', isLoading, callback)
// 机构信息提交
export const orgAdd = (data, isLoading, callback) => postData(`${version}/${SUPER_IDEN}/lib_list`, data, 'admin', isLoading, callback)
export const orgEdit = (orgID, data, isLoading, callback) => putData(`${version}/${SUPER_IDEN}/lib_list/${orgID}`, data, 'admin', isLoading, callback)

// 获取视频播放权限
export const orgGetVideoPlayauth = (data, isLoading, callback) => getData(`${version}/vod/play_auth`, data, 'admin', isLoading, callback)

// 机构列表
export const getOrgList = (data, isLoading, callback) => getData(`${version}/super/lib_search`, data, 'admin', isLoading, callback)
// 登录获取手机验证码
export const getCode = (data, isLoading, callback) => postData(`${version}/auth/send_sms`, data, 'admin', isLoading, callback)
// 注册
export const register = (data, isLoading, callback) => postData(`${version}/auth/register`, data, 'admin', isLoading, callback)
// 获取用户的信息
export const getUserInfo = (isLoading, callback) => getData(`${version}/${AUTH_IDEN}/user_detail`, '', 'admin', isLoading, callback)
// 修改报名信息
export const editUserInfo = (data, isLoading, callback) => postData(`${version}/auth/user_edit`, data, 'admin', isLoading, callback)
// 登录
export const login = (data, isLoading, callback) => postData(`${version}/auth/login`, data, 'admin', isLoading, callback)
// 超管
// 获取超管机构列表
export const getSuperOrg = (data, isLoading, callback) => getData(`${version}/super/lib_list`, data, 'admin', isLoading, callback)
// 创建机构
export const addOrg = (data, isLoading, callback) => postData(`${version}/super/lib_list`, data, 'admin', isLoading, callback)
// 编辑机构
export const editOrg = (id, data, isLoading, callback) => putData(`${version}/super/lib_list/${id}`, data, 'admin', isLoading, callback)
// 删除机构
export const orgRemove = (orgID, isLoading, callback) => delData(`${version}/${SUPER_IDEN}/lib_list/${orgID}`, '', 'admin', isLoading, callback)
// 超管查看用户信息
export const getSuperUser = (id, data, isLoading, callback) => getData(`${version}/super/${id}/user_detail`, data, 'admin', isLoading, callback)
// 报名单位查询
export const orgSearch = (data, isLoading, callback) => getData(`${version}/libs`, data, 'admin', isLoading, callback)
// 报名单位导出
export const orgSearchExport = (data, isLoading, callback) => getData(`${version}/export`, '', 'admin', isLoading, callback)
